import React from 'react'

import clsx from 'clsx'

/**
 * @typedef {Object} Props
 * @property {boolean} Props.disabled
 * @property {boolean} Props.checked
 * @property {(checked: boolean) => void} Props.onChange
 * @property {string} Props.text
 */

/**
 * @param {Props} props 
 * @param {React.ForwardedRef<HTMLInputElement>} ref
 */
function RadioButton(props, ref) {
    const {
        name,
        checked,
        defaultChecked,
        text,
        disabled,
        onChange,
        ...rest
    } = props

    const input = (
        <input type="radio"
            name={name}
            checked={checked}
            defaultChecked={defaultChecked}
            disabled={disabled}
            onChange={e => {
                if (onChange && !disabled) {
                    onChange(e.target.value)
                }
            }}
            ref={ref}
            {...rest}
        />
    )

    return <label
            className={clsx('label-set', {
                'label-set-disabled': disabled,
                'has-text': text !== '' && text,
            })}
            title={checked ? 'Poista valinta' : 'Valitse'}
            onClick={()=>{}}//do nothing because propagation stuff from Modals
        >
        {input}
        {text !== '' && text ? <span>{text}</span> : null}
    </label>
}

export default React.forwardRef(RadioButton)